/** Ink page color. Dark enough that status-bar text must stay white. */
export const STATUS_BAR_THEME_COLOR = "#0e0c0a";

/**
 * `black` is black status-bar text on current WebKit. `black-translucent`
 * keeps white text over the ink page, including after a client navigation.
 */
export const APPLE_STATUS_BAR_STYLE = "black-translucent" as const;

function ensureMeta(doc: Document, name: string, content: string): void {
  const parent = doc.head ?? doc.documentElement;
  const nodes = [...parent.querySelectorAll(`meta[name="${name}"]`)];
  if (nodes.length === 0) {
    const meta = doc.createElement("meta");
    meta.name = name;
    meta.content = content;
    parent.appendChild(meta);
    return;
  }

  // Keep the nodes React hydrated. Removing them makes the next client
  // navigation throw removeChild and stay on the previous screen.
  for (const node of nodes) {
    if (!(node instanceof HTMLMetaElement)) {
      continue;
    }
    if (node.content !== content) {
      node.content = content;
    }
    if (name === "theme-color" && node.hasAttribute("media")) {
      node.removeAttribute("media");
    }
    node.parentElement?.appendChild(node);
  }
}

/** Force WebKit and Chromium to read the dark status-bar theme again. */
export function refreshNativeStatusBarMeta(doc: Document): void {
  ensureMeta(doc, "theme-color", STATUS_BAR_THEME_COLOR);
  ensureMeta(doc, "apple-mobile-web-app-status-bar-style", APPLE_STATUS_BAR_STYLE);
  doc.documentElement.style.colorScheme = "dark";
}
